var _g, _g2, _g3, _g4, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDelete(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 24,
    viewBox: "0 0 23 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_i_1127_7411)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.1669 16.2004L10.1669 12.7004",
    stroke: "#F89500",
    strokeWidth: 3,
    strokeLinecap: "round"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_i_1127_7411)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.8338 16.2004L14.8338 12.7004",
    stroke: "#F89500",
    strokeWidth: 3,
    strokeLinecap: "round"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_i_1127_7411)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2 5.36743C1.17157 5.36743 0.5 6.039 0.5 6.86743C0.5 7.69586 1.17157 8.36743 2 8.36743V5.36743ZM20.3892 7.2044L21.2225 8.45167L20.3892 7.2044ZM19.8372 7.75642L21.0844 8.58968L19.8372 7.75642ZM5.16296 7.75627L3.91577 8.58964L5.16296 7.75627ZM6.08583 21.4485L5.02517 22.5091L6.08583 21.4485ZM18.9144 21.4485L17.8538 20.3878L18.9144 21.4485ZM2 8.36743H23V5.36743H2V8.36743ZM15.5002 20.5343H9.50004V23.5343H15.5002V20.5343ZM7.00004 18.0343V10.3675H4.00004V18.0343H7.00004ZM18.0002 10.3672V18.0343H21.0002V10.3672H18.0002ZM23 5.36743C22.3291 5.36743 21.713 5.36562 21.2054 5.41725C20.6727 5.47144 20.0957 5.59656 19.5559 5.95713L21.2225 8.45167C21.1871 8.47527 21.2134 8.43191 21.5089 8.40185C21.8295 8.36924 22.2667 8.36743 23 8.36743V5.36743ZM21.0002 10.3672C21.0002 9.63388 21.002 9.19676 21.0346 8.87616C21.0647 8.58063 21.108 8.55436 21.0844 8.58968L18.5899 6.92317C18.2293 7.46289 18.1042 8.03989 18.05 8.57259C17.9984 9.08023 18.0002 9.69631 18.0002 10.3672H21.0002ZM19.5559 5.95713C19.1736 6.21256 18.8453 6.54083 18.5899 6.92317L21.0844 8.58968C21.1209 8.53506 21.1678 8.48816 21.2225 8.45167L19.5559 5.95713ZM7.00004 10.3675C7.00004 9.69644 7.00185 9.08026 6.9502 8.57254C6.896 8.03975 6.77083 7.46267 6.41015 6.92289L3.91577 8.58964C3.89217 8.55432 3.93554 8.58059 3.96561 8.87616C3.99823 9.19681 4.00004 9.634 4.00004 10.3675H7.00004ZM2 8.36743C2.73347 8.36743 3.17066 8.36925 3.49131 8.40186C3.78688 8.43193 3.81315 8.4753 3.77783 8.4517L5.44458 5.95732C4.9048 5.59664 4.32772 5.47147 3.79493 5.41727C3.28721 5.36562 2.67103 5.36743 2 5.36743V8.36743ZM6.41015 6.92289C6.15481 6.54076 5.82671 6.21266 5.44458 5.95732L3.77783 8.4517C3.83242 8.48818 3.87929 8.53505 3.91577 8.58964L6.41015 6.92289ZM9.50004 20.5343C8.51483 20.5343 7.92682 20.5311 7.50537 20.4744C7.31225 20.4485 7.21553 20.4179 7.17197 20.4C7.16188 20.3958 7.15525 20.3926 7.15138 20.3906C7.14757 20.3886 7.14587 20.3875 7.14571 20.3873C7.14557 20.3873 7.14605 20.3876 7.14674 20.3881C7.14743 20.3887 7.1474 20.3887 7.14649 20.3878L5.02517 22.5091C5.64321 23.1272 6.39467 23.3521 7.10563 23.4477C7.77344 23.5375 8.59964 23.5343 9.50004 23.5343V20.5343ZM4.00004 18.0343C4.00004 18.9347 3.99686 19.7609 4.08664 20.4287C4.18223 21.1396 4.40712 21.8911 5.02517 22.5091L7.14649 20.3878C7.14557 20.3869 7.14562 20.3869 7.14618 20.3876C7.14675 20.3883 7.14706 20.3887 7.14697 20.3886C7.14686 20.3884 7.14576 20.3867 7.14376 20.3829C7.14174 20.3791 7.13851 20.3724 7.13436 20.3623C7.11644 20.3188 7.08585 20.2221 7.05989 20.0289C7.00323 19.6075 7.00004 19.0195 7.00004 18.0343H4.00004ZM15.5002 23.5343C16.4006 23.5343 17.2268 23.5375 17.8946 23.4477C18.6056 23.3521 19.357 23.1272 19.9751 22.5091L17.8538 20.3878C17.8528 20.3887 17.8528 20.3887 17.8535 20.3881C17.8542 20.3876 17.8547 20.3873 17.8545 20.3873C17.8544 20.3875 17.8527 20.3886 17.8489 20.3906C17.845 20.3926 17.8384 20.3958 17.8283 20.4C17.7847 20.4179 17.688 20.4485 17.4949 20.4744C17.0734 20.5311 16.4854 20.5343 15.5002 20.5343V23.5343ZM18.0002 18.0343C18.0002 19.0195 17.997 19.6075 17.9404 20.0289C17.9144 20.2221 17.8838 20.3188 17.8659 20.3623C17.8617 20.3724 17.8585 20.3791 17.8565 20.3829C17.8545 20.3867 17.8534 20.3884 17.8533 20.3886C17.8532 20.3887 17.8535 20.3883 17.8541 20.3876C17.8546 20.3869 17.8547 20.3869 17.8538 20.3878L19.9751 22.5091C20.5931 21.8911 20.818 21.1396 20.9136 20.4287C21.0034 19.7609 21.0002 18.9347 21.0002 18.0343H18.0002Z",
    fill: "#F89500"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter3_i_1127_7411)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.56531 2.5926C9.73401 2.41272 10.1057 2.25376 10.6229 2.1404C11.14 2.02703 11.7736 1.96558 12.4254 1.96558C13.0772 1.96558 13.7107 2.02703 14.2279 2.1404C14.745 2.25376 15.1167 2.41272 15.2854 2.5926",
    stroke: "#F89500",
    strokeWidth: 3,
    strokeLinecap: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_i_1127_7411",
    x: 8.66687,
    y: 11.2004,
    width: 3.33333,
    height: 6.83333,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 0.333328,
    dy: 0.333328
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.666656
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.19534 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_1127_7411"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_i_1127_7411",
    x: 13.3338,
    y: 11.2004,
    width: 3.33333,
    height: 6.83333,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 0.333328,
    dy: 0.333328
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.666656
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.19534 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_1127_7411"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_i_1127_7411",
    x: 0.5,
    y: 5.36743,
    width: 22.8333,
    height: 18.5001,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 0.333328,
    dy: 0.333328
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.666656
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.19534 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_1127_7411"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter3_i_1127_7411",
    x: 8.06531,
    y: 0.465576,
    width: 9.05342,
    height: 3.96028,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 0.333328,
    dy: 0.333328
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.666656
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.19534 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_1127_7411"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDelete);
export default __webpack_public_path__ + "static/media/delete.0c67c1c8e8a242b6289cc49fb13d0aaf.svg";
export { ForwardRef as ReactComponent };